module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 485
// module chunks = 1